import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PageService } from '../services/page.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { LoginService } from '../../auth/services/login.service';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';

@Component({
  selector: 'app-mi-cuenta',
  templateUrl: './mi-cuenta.component.html',
  styleUrls: ['./mi-cuenta.component.css'],
})
export class MiCuentaComponent implements OnInit {
  rol: any;
  name: any;
  colaboradores: any;
  colaborador: any;
  displayedColumns: string[] = ['nombre', 'info'];
  datasource: any;

  public dataForm: FormGroup;
  nombre;
  tipo;
  pass1;
  pass2;

  messageError: string;
  fieldTextType: boolean;
  fieldTextType2: boolean;

  @ViewChild('myDialog', { static: true }) myDialog: TemplateRef<any>;
  constructor(
    private pageService: PageService,
    private authService: LoginService,
    private dialog: MatDialog,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.rol = sessionStorage.getItem('rol');
    switch (this.rol) {
      case 'GRUPO':
        this.name = sessionStorage.getItem('name');
        this.colaboradores = JSON.parse(
          sessionStorage.getItem('colaboradores')
        );
        this.datasource = this.colaboradores;
        this.dataGrupo();
        break;

      default:
        this.pageService
          .getColaborador(sessionStorage.getItem('colaborador'))
          .subscribe((res) => {
            this.colaborador = res;
            console.log(this.colaborador);
            this.name = this.colaborador.apellido1;
            this.dataGrupo();
          });
    }
  }

  dataGrupo(): void {
    this.dataForm = new FormGroup({
      pass1: new FormControl('', [
        Validators.required,
        Validators.minLength(6),
      ]),
      pass2: new FormControl('', Validators.required),
    });
  }

  toggleFieldTextType(): any {
    this.fieldTextType = !this.fieldTextType;
  }

  toggleFieldTextType2(): any {
    this.fieldTextType2 = !this.fieldTextType2;
  }
  get pass1NoValido(): any {
    return (
      this.dataForm.get('pass1').invalid && this.dataForm.get('pass1').touched
    );
  }

  get pass2NoValido(): any {
    const pass1 = this.dataForm.get('pass1').value;
    const pass2 = this.dataForm.get('pass2').value;
    return pass1 !== pass2;
  }

  // Modal de info

  info(colaborador): void {
    this.pageService.getColaborador(colaborador).subscribe((res) => {
      this.colaborador = res;
      console.log(this.colaborador);
      this.dialog.open(this.myDialog, { hasBackdrop: true, width: '800px' });
    });
    //
  }

  guardar(): any {
    if (this.dataForm.invalid) {
      return Object.values(this.dataForm.controls).forEach((control) => {
        if (control instanceof FormGroup) {
          Object.values(control.controls).forEach((ctrl) =>
            ctrl.markAsTouched()
          );
        } else {
          control.markAsTouched();
        }
      });
    }
    Swal.fire({
      title: '',
      html: 'Espere por favor....!!',
      allowOutsideClick: false,
      showConfirmButton: false,
      willOpen: () => {
        Swal.showLoading();
      },
    });
    console.log(this.dataForm.value);
    const email = sessionStorage.getItem('email');
    this.authService.updatePassword(email, this.dataForm.value.pass1).subscribe(
      (datas) => {
        if (datas) {
          this.router.navigate(['/public/home/']);
        }
        Swal.close();
      },
      (error) => {
        console.log(error);
        Swal.fire('', 'Hubo un error, intentelo más tarde', 'warning');
      }
    );
  }
}
